import { render, staticRenderFns } from "./SingleButton.vue?vue&type=template&id=71bf79e0&"
import script from "./SingleButton.vue?vue&type=script&lang=js&"
export * from "./SingleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports